import React from "react";
import Switch from "react-switch";
import { connect } from "react-redux";
let checked = false;
class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
  }
  handleClick = (e, data) => {
    if (data == "and") {
      this.setState({ checked: false });
    } else {
      this.setState({ checked: true });
    }
    this.toggleReduxChange();
  };

  toggleReduxChange() {
    let selectedToggle = this.state.checked ? "AND" : "OR";
    let type =
      this.props.type == "Rule"
        ? "ADD_RULE_LEVEL_TOGGLE_SEGMENT"
        : "ADD_GROUP_LEVEL_TOGGLE_SEGMENT";
    this.props.dispatch({
      type: type,
      payload: selectedToggle,
      selectedIndex: this.props.selectedIndex,
      selectedRule: this.props.selectedRule
    });
    this.props.dispatch({ type: "Add_SEGMENT" });
  }

  render() {
    let selectedIndex = this.props.selectedIndex;
    let selectedRule = this.props.selectedRule;
    if (selectedRule !== "" && selectedIndex !== "no_index") {
      if (
        this.props.ruleLeveltoggleSegment.length > 0 &&
        this.props.ruleLeveltoggleSegment[selectedIndex] !== undefined &&
        this.props.ruleLeveltoggleSegment[selectedIndex][selectedRule] !==
          undefined
      ) {
        checked =
          this.props.ruleLeveltoggleSegment[selectedIndex][selectedRule] ===
          "AND"
            ? false
            : true;
      }
      this.state = { checked: checked };
    } else if (selectedIndex !== "no_index") {
      if (
        this.props.groupLeveltoggleSegment.length > 0 &&
        this.props.groupLeveltoggleSegment[0] !== undefined &&
        this.props.groupLeveltoggleSegment[0][selectedIndex][selectedIndex] !==
          undefined
      ) {
        checked =
          this.props.groupLeveltoggleSegment[0][selectedIndex] === "AND"
            ? false
            : true;
      }
      this.state = { checked: checked };
    } else {
      this.state = { checked: checked };
    }
    return (
      <React.Fragment>
        <span
          className={this.state.checked ? "andorbtn btnor" : "andorbtn btnand"}
          onClick={e => this.handleClick(e, "and")}
        >
          and
        </span>
        <span
          className={this.state.checked ? "andorbtn btnand" : " andorbtn btnor"}
          onClick={e => this.handleClick(e, "or")}
        >
          or
        </span>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  countSegment: state.countSegment,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  queryCountSegment: state.queryCountSegment
});

export default connect(mapStateToProps)(ToggleButton);



// WEBPACK FOOTER //
// ./src/views/Audiences/SegmentQueryBuilder/ToggleButton.jsx